import { useTranslation } from "react-i18next"
import { resolveLocale } from "tf-checkout-react"

/**
 * The checkout kit ships its own copy and defaults to en-GB, so omitting its
 * `locale` prop left every SDK surface — billing, payment, the auth modal,
 * order confirmation — in English inside an otherwise Spanish page. It accepts
 * exactly the locale codes this storefront ships, so the active language can be
 * handed straight over.
 *
 * Pass the result to every `<CheckoutProvider locale={...}>`. It tracks the
 * language switcher, so changing language re-renders the checkout too.
 */
export const useCheckoutLocale = () => {
  const { i18n } = useTranslation()

  // `resolveLocale` is the SDK's own coercion, so an unexpected value (a stale
  // stored preference, say) lands on its default rather than throwing.
  return resolveLocale(i18n.resolvedLanguage ?? i18n.language)
}
